<script>
	import { Table, DropdownItem } from "@sveltestrap/sveltestrap";
	import Pagination from "../../../components/CustomPaginate/Pagination.svelte";
	import CustomModal from "../../../components/CustomModal/CustomModal.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import BsLoader from "../../../components/Loader/BsLoader.svelte";
	import { convert } from "../../../services/helpers";
	import client from "../../../services/client";
	import { loadingStatus } from "../../../store/store";
	import { navigate } from "svelte-routing";
	import { extractErrorMessage } from "src/utils/misc";
	import TableDropdown from "../../../components/TableDropdown/TableDropdown.svelte";

	export let data;
	export let trigerSelectCarpark;

	const joinComma = (plate, i) => {
		if (i) {
			return plate.concat(",", " ");
		} else {
			return plate;
		}
	};

	let idStatus;
	async function handleStatus(id, status) {
		try {
			idStatus = id;
			loadingStatus.set(true);
			const res = await client("/v1/carParks/status", {
				method: "PUT",
				version: "Vehicle",
				data: {
					id,
					status,
				},
			});
			if (res.status === 200) {
				trigerSelectCarpark("update");
				loadingStatus.set(true);
			} else {
				loadingStatus.set(false);
			}
		} catch (err) {
			loadingStatus.set(false);
			extractErrorMessage(err);
			console.log(err);
		}
	}
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>Car park ID</th>
				<th class="col-3">Vehicle plate number</th>
				<th class="col-2">Address</th>
				<th>Postal code</th>
				<th>No. of lots</th>
				<th>Start date</th>
				<th>End date</th>
				<th>Status</th>
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { id, name, vehicles, address, postalCode, lotCount, activeFrom, activeTo, status }}
				<tr>
					<td>
						<p>
							<span
								on:keyup={() => {}}
								class="link link-text"
								on:click={() =>
									navigate(
										`/carpark-management/details/${id}`
									)}
							>
								{name}
							</span>
						</p>
					</td>
					<td>
						<p class="link text-right">
							{#each vehicles as { plateNumber, vehicleId }, i}
								{#if vehicles.length > 1}
									<span
										on:keyup={() => {}}
										class="link-text mx-1"
										on:click={() =>
											navigate(
												`/car-management/details/${vehicleId}`
											)}
										>{joinComma(
											plateNumber,
											vehicles.length - 1 !== i
										)}</span
									>
								{:else}
									<span
										on:keyup={() => {}}
										class="link link-text"
										on:click={() =>
											navigate(
												`/car-management/details/${vehicleId}`
											)}>{plateNumber}</span
									>
								{/if}
							{/each}
						</p>
					</td>
					<td>
						<p>
							<span> {address} </span>
						</p>
					</td>
					<td>
						<p>
							<span> {postalCode} </span>
						</p>
					</td>
					<td>
						<p>
							<span> {lotCount} </span>
						</p>
					</td>
					<td>
						<p>
							<span>{convert(activeFrom)} </span>
						</p>
					</td>
					<td>
						<p>
							<span> {convert(activeTo)} </span>
						</p>
					</td>
					<td>
						{#if status}
							{#if $loadingStatus && idStatus == id}
								<p>&nbsp; &nbsp; <BsLoader /></p>
							{:else}
								<p class="status-bar status-bar-1">Active</p>
							{/if}
						{:else if $loadingStatus && idStatus == id}
							<p>&nbsp; &nbsp; <BsLoader /></p>
						{:else}
							<p class="status-bar status-bar-3">Inactive</p>
						{/if}
					</td>
					<td>
						<TableDropdown>
							<DropdownItem
								on:click={() =>
									navigate(
										`/carpark-management/details/${id}`
									)}>View Details</DropdownItem
							>

							{#if status}
								<DropdownItem
									on:click={() => handleStatus(id, false)}
									>Set as Inactive</DropdownItem
								>
							{:else}
								<DropdownItem
									on:click={() => handleStatus(id, true)}
									>Set as Active</DropdownItem
								>
							{/if}
						</TableDropdown>
					</td>
				</tr>
			{/each}
			{#if data.totalCount == 0}
				<tr>
					<td colspan="9" class="text-center">No data to display</td>
				</tr>
			{/if}
		</tbody>
	</Table>
	<Pagination totalRecord={data.totalCount} />
	<CustomModal />
</LoaderContainer>
